import {Injectable} from '@angular/core';
import {Menu} from '../_model/menu';

@Injectable({
  providedIn: 'root',
})
export class UtilService {

  urlCodigoEtica: string;

  constructor() {
  }

  getMenus(): Menu[] {
    let menus: Menu[] = [];

    let menuHome = {nome: 'Home', url: '/'};
    menus.push(menuHome);

    let menuRodobens = {
      id: 'roodobens', nome: 'Rodobens', url: '#', submenus: [
        {id: 'a-empresa', nome: 'A Empresa', url: '/paginas/a-empresa', target: '_self'},
        {id: 'parceiros', nome: 'Parceiros', url: '/paginas/parceiros', target: '_self'},
        {id: 'politica-ambiental', nome: 'Política Ambiental', url: '/paginas/politica-ambiental', target: '_self'},
        {id: 'noticias', nome: 'Notícias', url: '/paginas/noticias', target: '_self'},
        {nome: 'Código de Ética', url: this.urlCodigoEtica, target: '_blank'},
        {nome: 'Canal de Denúncia', url: 'https://canaldedenuncia.com.br/empresasrodobens', target: '_blank'}
      ]
    };
    menus.push(menuRodobens);

    let menuConcessionarias = {nome: 'Concessionárias', url: '/concessionarias'};
    menus.push(menuConcessionarias);

    let menuVeiculos = {nome: 'Veículos', url: '/veiculos'};
    menus.push(menuVeiculos);

    let menuPecasServicos = {
      id: 'pecasServicos', nome: 'Peças e Serviços', url: '#', submenus: [
        {id: 'cotacao-pecas', nome: 'Peças', url: '/cotacao-pecas', target: '_self'},
        {id: 'pneus-michelin', nome: 'Pneus Michelin', url: '/paginas/pneus-michelin', target: '_self'},
        {id: 'pneus-apollo', nome: 'Pneus Apollo', url: '/paginas/pneus-apollo', target: '_self'},
        {id: 'pecas-renov', nome: 'Peças Renov (Remanufaturadas)', url: '/paginas/pecas-renov', target: '_self'},
        {id: 'agendamento', nome: 'Agendamento', url: '/agendamento', target: '_self'},
        {id: 'servico-expresso', nome: 'Serviço Expresso', url: '/paginas/servico-expresso', target: '_self'},
        {id: 'oficina-movel', nome: 'Oficina Móvel', url: '/paginas/oficina-movel', target: '_self'},
        {
          id: 'mercedes-assistance',
          nome: 'Mercedes-Benz Service 24h',
          url: '/paginas/mercedes-assistance',
          target: '_self'
        },
        {
          nome: 'Plano de Manutenção',
          url: 'https://www.mercedes-benz-trucks.com.br/caminhoes/servicos-e-pecas/planos-manutencao ',
          target: '_blank'
        },
        {nome: 'Consulta Recall', url: 'https://www.mercedes-benz-trucks.com.br/consulta-recall ', target: '_blank'}
      ]
    };
    menus.push(menuPecasServicos);

    let menuContatos = {
      id: 'contatos', nome: 'Contatos', url: '#', submenus: [
        {id: 'fale-conosco', nome: 'Fale Conosco', url: '/fale-conosco', target: '_self'},
        {nome: 'Trabalhe Conosco', url: 'https://rodobenscarreiras.gupy.io/', target: '_blank'},
        {id: 'seja-parceiro', nome: 'Seja Parceiro', url: '/paginas/seja-parceiro', target: '_self'}
      ]
    };
    menus.push(menuContatos);

    return menus;
  }

  getMenu(rota: string): Menu {
    let menus = this.getMenus();
    let menu = menus.filter(e => e.submenus && e.submenus.some(s => s.id == rota))[0];
    return menu;
  }
}
